import {
  get, post, update, get2, upload, download
} from './helpers'

export function resetAkun($data) {
  return post('/reset-akun', $data)
}

// API GENERAL
export function downloadFileDashboard(filename) {
  return download(`/general/dashboard/download/dokumen/${filename}`)
}
export function getUserDetail(uuid) {
  return get(`/general/user/detail?uuid=${uuid}`)
}
export function getUserDetailDashboard(uuid) {
  return get(`/general/user/detail?dashboard=true&uuid=${uuid}`)
}
export function uploadFoto(file, metadata, onUploadProgress) {
  return upload('/general/user/uploadfile', file, metadata, onUploadProgress)
}
export function ubahUserData($data) {
  return post('/general/user/detail/update', $data)
}
export function getDetailHasilSidang(uuid) {
  return get(`/general/hasil-sidang/detail/${uuid}`)
}
export function updateCatatanHasilSidang($data) {
  return post('/general/hasil-sidang/catatan/update', $data)
}
export function updateJawabanPenilaianHasilSidang($data) {
  return post('/general/hasil-sidang/jawaban-penilaian/update', $data)
}
// END API GENERAL

//API ADMIN
export function kirimUlangNotifikasi(uuid) {
  return post(`/admin/notifikasi/resend?uuid=${uuid}`)
}
export function updatePeriodeUjian($data) {
  return post('admin/periode-ujian/update', $data)
}
export function getPeriodeUjian($data) {
  return get('admin/periode-ujian')
}
export function activationUser($data) {
  return post('/admin/pengguna/activation', $data)
}
export function postPengguna($data) {
  return post('/admin/pengguna/post', $data)
}
export function postRegister($data) {
  return post('/account/register', $data)
}
export function postLupaPassword($data) {
  return post('/lupa-password', $data)
}
export function postResetPassword($data) {
  return post('/reset-password', $data)
}
export function updateStatusByAdmin($data) {
  return post('/admin/status-hasil-sidang/update', $data)
}
export function generateDosen($data) {
  return get('/admin/bulkRegisterFromDosen', $data)
}
export function getDetailJadwalSidang(uuid) {
  return get(`/admin/jadwal-sidang/detail?uuid=${uuid}`)
}
export function updateJadwalSidang($data) {
  return post('/admin/jadwal-sidang/update', $data)
}

export function getTokenSso(secret) {
  return get(`/get-token-sso/${secret}`)
}

export function logoutSSO() {
  return get(`/cas/logout`)
}

export function exportRekapitulasiPengajuanSidang($data) {
  return get2('/admin/export-rekapitulasi-pengajuan-sidang', $data)
}
export function exportRekapitulasiPayroll($data) {
  return get2('/admin/export-rekapitulasi-payroll', $data)
}

export function exportRekapitulasiJadwalSidang($data) {
  return get2('/general/export-rekapitulasi-jadwal-sidang', $data)
}
//END API ADMIN

// API MAHASISWA
export function updateDataMahasiswa($data) {
  return post(`/mahasiswa/pengajuan-yudisium/update`, $data)
}
export function getPengajuanYudisium(uuid) {
  return get(`/mahasiswa/pengajuan-yudisium/detail/${uuid}`)
}
export function postPengajuanYudisium($data) {
  return post('/mahasiswa/pengajuan-yudisium', $data)
}
export function postWaktuUjian($data) {
  return post('/mahasiswa/waktu-ujian/tambah', $data)
}
export function deleteWaktuUjian($data) {
  return post('/mahasiswa/waktu-ujian/delete', $data)
}
export function postPembimbing($data) {
  return post('/mahasiswa/pembimbing/tambah', $data)
}
export function deletePembimbing($data) {
  return post('/mahasiswa/pembimbing/delete', $data)
}
export function postPenguji($data) {
  return post('/mahasiswa/penguji/tambah', $data)
}
export function deletePenguji($data) {
  return post('/mahasiswa/penguji/delete', $data)
}
export function postBerkas() {
  return post('/mahasiswa/pengajuan-sidang/baru')
}
export function updateStatusYudisium($data) {
  return post('/mahasiswa/pengajuan-yudisium/ajukan', $data)
}
export function deleteYudisium($data) {
  return post('/mahasiswa/pengajuan-yudisium/delete', $data)
}
export function updateBerkas($data) {
  return post('/mahasiswa/pengajuan-sidang/update', $data)
}
export function updateBerkasYudisium($data) {
  return post('/mahasiswa/pengajuan-yudisium/update', $data)
}
export function getPengajuanSidangDetail(uuid,jenjangUUID) {
  return get(`/mahasiswa/pengajuan-sidang/detail/${uuid}?jenjang_uuid=${jenjangUUID}`)
}
export function uploadFilePengajuan(file, metadata, onUploadProgress) {
  return upload('/mahasiswa/pengajuan-sidang/uploadfile', file, metadata, onUploadProgress)
}
export function downloadDokumen(filename) {
  return download(`/mahasiswa/pengajuan-sidang/download/dokumen/${filename}`)
}
export function deletePengajuanSidang(uuid) {
  return post(`/mahasiswa/pengajuan-sidang/delete/${uuid}`)
}
export function updateBerkasHasilSidang($data) {
  return update('/mahasiswa/berkas-hasil-sidang/update', $data)
}
export function postNotifUpdateBerkas($data) {
  return post('/mahasiswa/berkas-hasil-sidang/notification', $data)
}
export function uploadFileBerkasHasilSidang(file, metadata, onUploadProgress) {
  return upload('/mahasiswa/berkas-hasil-sidang/uploadfile', file, metadata, onUploadProgress)
}
export function downloadBerkasHasilSidang(filename) {
  return download(`/mahasiswa/berkas-hasil-sidang/download/dokumen/${filename}`)
}
export function downloadSuratTugas(filename) {
  return download(`/dekanat/surat-tugas/download/dokumen/${filename}`)
}
export function generateSuratTugas($data) {
  return post('/dekanat/surat-tugas/generate', $data)
}
export function generateSKTMT($data) {
  return post(`/dekanat/sktmt/generate`, $data)
}
export function getSuratTugasPengujiTanpaNomor($data) {
  return get(`/dekanat/total/surat-tugas-penguji-tn`, $data)
}
export function postProsesNomorSuratTugasPenguji($data) {
  return post(`/dekanat/proses/surat-tugas-penguji-tn`, $data)
}
export function postProsesNomorSuratTugasPembimbing($data) {
  return post(`/dekanat/proses/surat-tugas-pembimbing-tn`, $data)
}
export function getSuratTugasPembimbingTanpaNomor($data) {
  return get(`/dekanat/total/surat-tugas-pembimbing-tn`, $data)
}

// END API MAHASISWA

// API PEMBIMBING
export function postTerimaBerkas($data) {
  return post('/pembimbing/terima-berkas', $data)
}
export function postTolakBerkas($data) {
  return post('/pembimbing/tolak-berkas', $data)
}
export function postMulaiSidang($data) {
  return post('/pembimbing/mulai-sidang', $data)
}
export function updateStatusHasilSidang($data) {
  return post('/pembimbing/status-hasil-sidang', $data)
}
export function postPermintaanPerubahanNilai($data) {
  return post('/pembimbing/perubahan-nilai', $data)
}
export function postTandaiSelesai($data) {
  return post('/pembimbing/selesai', $data)
}
export function updateBeritaAcara($data) {
  return post('/pembimbing/update-berita-acara', $data)
}
export function downloadBeritaAcara(filename) {
  return download(`/pembimbing/download/berita-acara/${filename}`)
}
export function buildBeritaAcara($data) {
  return post(`pembimbing/build/berita-acara`, $data)
}
export function simpanNoteBerkas($data) {
  return post(`pembimbing/note/berkas`, $data)
}
export function postBatalkanUjian($data) {
  return post(`pembimbing/batalkan-ujian`, $data)
}

// END API PEMBIMBING

export function getDetailPerubahanNilaiHasilSidang(uuid) {
  return get(`/kaprodi/perubahan-nilai/hasil-sidang/${uuid}`)
}
export function updatePerubahanNilai($data) {
  return post(`kaprodi/perubahan-nilai`, $data)
}

// MASTER DATA
export function getJenisKelamin() {
  return get('/general/master/jenis-kelamin')
}
export function getJurusan() {
  return get('/general/master/jurusan')
}
export function getJenjang() {
  return get('/general/master/jenjang')
}
export function getProdi(jenjangUUID) {
  return get(`/general/master/prodi?jenjang_uuid=${jenjangUUID}`)
}
export function getPeminatan() {
  return get('/general/master/peminatan')
}
export function getProvinsi() {
  return get('/general/master/provinsi')
}
export function getKota(provinsiId) {
  return get(`/general/master/kota/${provinsiId}`)
}
export function getJenisSidang() {
  return get('/general/master/jenis-sidang')
}
export function getProsesPersidangan() {
  return get('/general/master/proses-persidangan')
}
export function getDosen() {
  return get('/general/master/dosen')
}
export function getRuangan() {
  return get('/general/master/ruangan')
}
export function getRole() {
  return get('/general/master/role')
}
export function getProgram() {
  return get('/general/master/program')
}
export function getWaktuUjian() {
  return get('/general/master/waktu-ujian')
}
export function getJawabanPersetujuan() {
  return get('/general/master/jawaban-persetujuan')
}
export function getStatusHasilSidang() {
  return get('/general/master/status-hasil-sidang')
}
export function getStatusPengajuanSidang() {
  return get('/general/master/status-pengajuan-sidang')
}
export function getStatusJadwalSidang() {
  return get('/general/master/status-jadwal-sidang')
}
export function getTotalDosenTanpaAkun() {
  return get('/general/master/dosen-tanpa-akun')
}
// END MASTER DATA



